import { FormFieldTypes } from "../../../../data/formFieldType";

export const AccountInformationData = {
  name: "AdditionalInfo",
  initialState: {
    membershipStatus: null,
    membershipType: null,
    discontinuedReason: null,
    joinedDate: null,
    updatedDate: null,
    discontinuedReason: null,
    isOptOutExpiry: false,
    isOptOutTermination: false,
    OtherDiscontinuedReason: null,
    domainInfo : null
  },
  formFields: [
    {
      id: "membershipStatus",
      lable: "Membership Status",
      Field_Name: "Membership Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "membershipStatus",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 mb-3",
      },
    },
    {
      id: "membershipType",
      lable: "Membership Type",
      Field_Name: "Membership Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "membershipType",
      fieldSetting: {
        placeholder: "",
        options: [],
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-3"
      }
    },
    {
      id: "joinedDate",
      lable: "Joined Date",
      Field_Name: "Joined Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "joinedDate",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2",
      },
    },
    {
      id: "updatedDate",
      lable: "Updated Date",
      Field_Name: "Updated Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "updatedDate",
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2",
      },
    },
    {
      id: "discontinuedReason",
      lable: "Discontinued Reason",
      Field_Name: "Discontinued Reason",
      fieldType: FormFieldTypes.SELECT,
      dataField: "discontinuedReason",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true,
      },
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2",
      },
    },
    // {
    //   id: "isOptOutExpiry",
    //   lable: "Opt-Out Expiry",
    //   Field_Name: "Opt-Out Expiry",
    //   fieldType: FormFieldTypes.CHECKBOX,
    //   dataField: "isOptOutExpiry",
    //   fieldSetting: {
    //     placeholder: "",
    //     allowSpace: true,
    //     // isDisable: true,
    //   },
    //   style: {
    //     containerCss: "col-md-3 mb-2 mt-4",
    //   },
    // },
    // {
    //   id: "isOptOutTermination",
    //   lable: "Opt-Out Termination",
    //   Field_Name: "Opt-Out Termination",
    //   fieldType: FormFieldTypes.CHECKBOX,
    //   dataField: "isOptOutTermination",
    //   fieldSetting: {
    //     placeholder: "",
    //     allowSpace: true,
    //     // isDisable: true,
    //   },
    //   style: {
    //     containerCss: "col-md-3 mb-2 mt-4",
    //   },
    // },
    {
      id: "OtherDiscontinuedReason",
      lable: "Others Discontinued Reason",
      Field_Name: "Others Discontinued Reason",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "OtherDiscontinuedReason",
      fieldSetting: {
        placeholder: "",
        isDisable: true,
      },
      validation: [],
      style: {
        containerCss: "col-lg-6 col-xl-6 col-md-6 col-sm-12 col-12 mb-2 d-none",
      },
    },
    {
      id: "domainInfo",
      lable: "Domain Information",
      Field_Name: "Domain Information",
      fieldType: FormFieldTypes.INPUT,
      dataField: "domainInfo",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable:false
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3 mt-auto",
      },
    },
    {
      id: "isOptOutExpiry",
      lable: "Opt-Out Expiry",
      Field_Name: "Opt-Out Expiry",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "isOptOutExpiry",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        // isDisable: true,
      },
      style: {
        containerCss: "col-md-3 mb-2 mt-4",
      },
    },
    {
      id: "isOptOutTermination",
      lable: "Opt-Out Termination",
      Field_Name: "Opt-Out Termination",
      fieldType: FormFieldTypes.CHECKBOX,
      dataField: "isOptOutTermination",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        // isDisable: true,
      },
      style: {
        containerCss: "col-md-3 mb-2 mt-4",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};